// ProductMoreInfo.jsx
import React from "react";

export default function ProductMoreInfo({ isMobile }) {
  return (
    <div>
      {/* TABS */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "10px" : "15px",
          marginTop: "40px",
          flexWrap: "wrap",
          justifyContent: isMobile ? "center" : "flex-start",
        }}
      >
        <button style={activeTab}>Description</button>
        {/* <button style={tab}>Reviews</button>
        <button style={tab}>Resources</button> */}
      </div>

      {/* FULL DESCRIPTION */}
      <p style={{ marginTop: "20px" }}>
       Turmeric powder is a bright yellow spice made from dried turmeric roots, known for its warm, earthy flavour and vibrant colour. Rich in curcumin, it’s widely 
used in cooking, natural medicine, and cosmetics. Turmeric offers powerful antioxidant and anti-inflammatory benefits, making it both a flavourful and 
health-boosting ingredient.


      </p>

      <h3>Key Features:</h3>
      <ul>
        <li>Bright yellow-orange powder with a warm, earthy flavour</li>
        <li>Contains curcumin, a powerful natural antioxidant and anti-inflammatory compound</li>
        <li>100% pure, finely ground from dried turmeric rhizomes</li>
        <li>Long shelf life and versatile in use</li>
      </ul>

      <h3>Nutritional Benefits:</h3>
      <ul>
        <li>Widely used in culinary dishes (curries, soups, teas)</li>
        <li>Natural food colouring and flavouring agent
Used in traditional medicine (Ayurveda, Chinese medicine)</li>
        <li>Ingredient in cosmetics, skincare, and health supplements</li>
      </ul>  

      <h3>Applications:</h3>
      <ul>
      <li>Rich in antioxidants that help neutralise free radicals</li>
      <li>Supports joint health and may reduce inflammation, Aids digestion and supports liver health</li>
      <li>May boost immunity and brain function</li>
      </ul>

      <h3>Advantages:</h3>
      <ul>
        <li>Natural and chemical-free alternative to synthetic additives</li>
        <li>Promotes overall wellness with regular consumption
Can be consumed fresh, in capsules, or mixed in drinks</li>
        <li>Easy to incorporate into daily diets and routines</li>
      </ul>
    </div>
  );
}

const activeTab = {
  padding: "10px 20px",
  background: "green",
  color: "white",
  borderRadius: "8px",
  border: "none",
};

const tab = {
  padding: "10px 20px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};
